import AddSitePhotoModal from "../components/AddSitePhotoModal";
import { useUploadFile } from "../operations/mutations/uploadFile";
import { useEffect, useState } from "react";
import { UserFile } from "../models/UserFile";

interface Props {
  open: boolean;
  onPhotoAdded: (comments: string, photo: UserFile) => void;
  onClose: () => void;
}

const AddSitePhotoModalContainer = ({ open, onPhotoAdded, onClose }: Props) => {
  const [userFile, setUserFile] = useState<UserFile>();

  const {
    mutate: uploadFileMutate,
    data: uploadFile,
    error: uploadFileError,
    loading: uploadFileLoading,
  } = useUploadFile();

  const handleUploadFile = (userFile: UserFile) => {
    setUserFile(userFile);
    uploadFileMutate({
      variables: {
        file: userFile.file,
        fileId: userFile.id,
      },
    });
  };

  useEffect(() => {
    if (userFile) {
      if (uploadFile?.uploadFile?.fileId) {
        setUserFile({ ...userFile, uploadStatus: { ...userFile.uploadStatus, uploaded: true, uploading: false } });
      } else if (uploadFileError && uploadFileError.graphQLErrors) {
        setUserFile({
          ...userFile,
          uploadStatus: { ...userFile.uploadStatus, uploading: false, uploadError: uploadFileError.graphQLErrors[0] },
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadFile, uploadFileError]);

  return (
    <AddSitePhotoModal
      open={open}
      onClose={onClose}
      onAddPhoto={onPhotoAdded}
      userFile={userFile}
      onUploadFile={handleUploadFile}
      uploading={uploadFileLoading}
    ></AddSitePhotoModal>
  );
};

export default AddSitePhotoModalContainer;
